import React, { ReactNode } from 'react';

import { Colors } from '~/src/scss/common/style';
import styled from 'styled-components';

interface Props {
  children?: ReactNode | ReactNode[];
  title?: string;
}

export default function FormRow({ children, title }: Props): JSX.Element {
  return (
    <FormRowWrapper className="form-row form-group">
      {title ? <Title className="col-sm-12">{title}</Title> : null}
      {children}
    </FormRowWrapper>
  );
}

const Title = styled.h1`
  color: ${Colors.darkBrown};
  font-size: 20px;
  wont-weight: 700;
  text-align: center;
`;

const FormRowWrapper = styled.div`
  margin-bottom: 40px;
`;
